/**
 * Format an ISO datetime in the viewer's local timezone (browser / device locale).
 * Uses explicit Intl fields — dateStyle/timeStyle cannot be mixed with timeZoneName in all browsers.
 */
export function formatInUserLocalTime(isoString) {
  if (!isoString) return null;
  const when = new Date(isoString);
  if (Number.isNaN(when.getTime())) return null;

  try {
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
    }).format(when);
  } catch {
    try {
      return when.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    } catch {
      return when.toLocaleString();
    }
  }
}

export function formatAccountLockoutMessage(lockoutUntilIso) {
  const whenLocal = formatInUserLocalTime(lockoutUntilIso);
  if (!whenLocal) {
    return (
      "Account temporarily locked after too many failed login attempts. " +
      "Please try again later."
    );
  }
  return (
    "Account temporarily locked after too many failed login attempts. " +
    `You can sign in again after ${whenLocal}.`
  );
}
